export const ROUTES = {
  // EDIT_PROFILE: 'EDIT_PROFILE',
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  PROFILE: "PROFILE",
  // TERMS_CONDITIONS: "TERMS_CONDITIONS",
  // PRIVACY_POLICY: "PRIVACY_POLICY",
  CONTACT_US: "CONTACT_US",
  COMMISSION: "COMMISSION",
  POINTS: "POINTS",
};
